import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/common/table/Table";
import { history } from "../../../_helpers";
import { Link, useLocation } from "react-router-dom";
import {
  masterActions,
  staffRequestAction,
  authActions,
  facilityAction,
} from "../../../_store";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../components/common/ui/Loader";
import {
  requestFormChangeFormTypeValidation,
  staffRequestSchema,
} from "../../../validation/staffRequestSchema";
import FormHeader from "./FormHeader";
import { StoredProcedures, UserRoleType } from "../../../_helpers/enumerator";
import ExcelExport from "../../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../../components/common/export/generateXlsx";
import {
  formatDateTimeAMPM,
  getCurrentDate,
  getCurrentTime,
} from "../../../utils/formatTime";
import PdfViewer from "../../../components/common/PdfViewer/PdfViewer";
//import useTranslate from "../../../utils/useTranslation";
import translateText from "../../../_helpers/GoogleTranslator";
import { getStoredValue } from "../../../_helpers/storagehelper";

function RequestFormInfo() {
  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  // const { translatedMessages, translateMessages } = useTranslate();

  const formID = location?.state ? location?.state?.formID : 0; //request type ID

  const formDetails = location?.state ? location?.state?.formDetails : {};
  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;

  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const STAFF_REQUEST_ACCESSIBLE_FA = [staffRequestID];

  const InmateID = location?.state ? location?.state?.InmateID : 0;
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  const InmateResidentId = location?.state
    ? location?.state?.InmateResidentId
    : 0;

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const oldRequestFormTitle = location?.state
    ? location?.state?.oldRequestFormTitle
    : 0;

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const {
    requestFormInfoResponse,
    formTypeListDropDown,
    loadInmateRequestFormList,
    updateRequestFormTypePopupdata,
    updateChangeRequestFormTypeData,
    submitRequestFormInfoResponse,
    requestReview,
    requestFormInfoPayloadData,
    indexValue,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ReplyMode } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const managementUserID = user?.ManagementUserID;
  const userRoleID = user?.UserRoleID;
  // const [facilityName, setFacilityName] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [formType, setFormType] = useState(1);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [selectLang, setselectLang] = useState("");
  const [transLoader, setTransLoader] = useState(false);
  const [updateRequestColumn, setUpdateRequestColumn] = useState([]);
  const [updatePostByColumn, setUpdatePostByColumn] = useState([]);
  const [requestFormTypePopup, setRequestFormTypePopUp] = useState({
    requestFormTypeID: RequestFormType,
    newRequestFormTypeId: 0,
    inmateResidentId: InmateResidentId,
    facilityCode: facilityCode,
  });

  const [updateRequestFormType, setUpdateRequestFormType] = useState({
    facilityID: facilityCode,
    oldRequestFormTypeID: RequestFormType,
    newRequestFormTypeID: requestFormTypePopup?.newRequestFormTypeId,
    requestForumThreadID: formID,
    managementUserID: loggedUser,
    oldRequestFormTitle: oldRequestFormTitle,
    newRequestFormTitle: "",
  });

  const [requestFormTable, setRequestFormTable] = useState({
    formID: 0,
    pageNo: 1,
    rowCountPerPage: 10,
  });
  const [pdfdata, setpdfdata] = useState(null);
  const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);

  const prevFacilityCodeRef = useRef(facilityCode);

  // const [updateRequestFormInfoPayloadData, setRequestFormData] = useState({
  // folderPath: "",
  // filename: "",
  // file: "",
  // requestForumThreadID: "",
  // facilityID: facilityCode,
  // facilityCode: "",
  // inmatesId: "",
  // managementUserID: loggedUser,
  // activeStatus: 0,
  // noticesTitle: "",
  // pdfAttachPath: "",
  // postType: 1,
  // });

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({
        facilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    if (
      userRoleID !== UserRoleType?.SuperAdmin &&
      !STAFF_REQUEST_ACCESSIBLE_FA?.includes(managementUserID) &&
      managementUserID &&
      RequestFormType &&
      facilityCode
    ) {
      dispatch(
        staffRequestAction?.getRequestFormAccess({
          ManagementUserID: managementUserID,
          formID: RequestFormType,
          FacilityCode: facilityCode,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (Object?.keys(data)?.length > 0) {
            if (
              data?.FormRespond === 0 ||
              requestFormInfoResponse?.RequestCurrentStatus === "Closed"
            ) {
              setShowReplyModal(false);
            } else {
              setShowReplyModal(true);
            }
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get permission data", "error");
        });
    } else {
      if (requestFormInfoResponse?.RequestCurrentStatus === "Closed") {
        setShowReplyModal(false);
      } else {
        setShowReplyModal(true);
      }
    }
    //adde in 226 useEffect
  }, [
    RequestFormType,
    managementUserID,
    facilityCode,
    formID,
    // userRoleID,
    // STAFF_REQUEST_ACCESSIBLE_FA,
    // dispatch,
    // requestFormInfoResponse?.RequestCurrentStatus,
    requestFormInfoResponse,
  ]);

  useEffect(() => {
    if (formID > 0) {
      getRequestFormDetails();
      getFormThreadListForTable();
    }
    else {
      history.navigate("/Admin/StaffRequestList");
    }
  }, [
    location?.state?.formID,
    requestFormTable?.pageNo,
    requestFormTable?.rowCountPerPage,
    indexValue,
    formID,
    InmateID,
  ]);

  const getRequestFormDetails = () => {
    dispatch(
      staffRequestAction.getRequestFormInfo({
        formID: formID,
        InmateID: InmateID,
        FacilityCode: facilityCode,
      })
    )
      .then((result) => {
        // const data = result?.payload;
        // dispatch(
        //   staffRequestAction?.resetMessageToInmateRequestFormPayloadData()
        // );
        // setRequestFormData(searchData);
        // if (data?.RequestCurrentStatus === "Open") {
        //   setShowReplyModal(true);
        // } else {
        //   setShowReplyModal(false);
        // }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const getFormThreadListForTable = () => {
    const request = { ...requestFormTable };
    request.formID = formID;
    dispatch(staffRequestAction?.loadInmateRequestForumThreadList(request))
      .then((res) => {
        if (res?.payload) {
          handleTranslate(selectLang, res?.payload);
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const handleConfirmRequestFormTypeChange = () => {
    dispatch(staffRequestAction.updateChangeRequestFormType(updateRequestFormType));
    const LakefacilityId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_FACILITY_ID;
    const DisciplinaryreqId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_REQ_ID;
    const FacilityID = getStoredValue("commonFacilityCode");
    const facilityList = getStoredValue("facilityDropDown") || [];
    const facilityName = facilityList?.find(fac => fac.value == FacilityID)?.label || "";
    if (updateRequestFormType?.newRequestFormTypeID == DisciplinaryreqId && FacilityID == LakefacilityId) {
      dispatch(staffRequestAction.loadSendEmailToDisciplinaryReportAppeals({
        facilityName: facilityName,
        emailTo: process.env.REACT_APP_AUTO_GENERATE_EMAIL_TO,
        inmateName: requestFormInfoResponse?.InmateFullName,
        inmateId: requestFormInfoResponse?.InmateResidentId,
        appealSubmissionDateTime: requestFormInfoResponse?.RequestCreateDate
      }))
    }
  }

  useEffect(() => {
    switch (updateRequestFormTypePopupdata?.IsSucceed) {
      case 1:
        Popup({
          title: "Message",
          text: `Your chosen form is not allow to create the new request by 
          Inmates but your selected form is allow to create the New request 
          by Inmates. If you want to proceed, Admin  is not allow to create 
          the New request. Are you sure, you want to reassign the selected 
          form to chosen form?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () => { handleConfirmRequestFormTypeChange() },
        });
        dispatch(staffRequestAction?.resetForm());
        break;
      case 2:
        Popup({
          title: "Message",
          text: `Your chosen form limit is Zero. 
          If you want to proceed, Inmates not allow to create this request form. 
          Admin only allow to create the new request.
          Are you sure, you want to reassign the selected form to chosen form ?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () => { handleConfirmRequestFormTypeChange() },
        });
        dispatch(staffRequestAction?.resetForm());
        break;

      case 0:
        Popup({
          title: "Message",
          text: `Are you sure you want to Re-assign this Forum to another Forum type?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () => { handleConfirmRequestFormTypeChange() },
        });
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [updateRequestFormTypePopupdata]);

  useEffect(() => {
    if (updateChangeRequestFormTypeData?.IsSucceed > 0) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode ? commonFacilityCode : 0,
          ProcedureName: StoredProcedures?.ChangedFormType,
          UserAction: `UspMoveForumFormToNewForum ( RequestForumThreadID - ${formID} )`,
        })
      );
      showToastNotification("Form Reassigned Successfully.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
    if (updateChangeRequestFormTypeData?.IsSucceed === -1) {
      showToastNotification("'Forum thread not found.", "error");
      // history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
  }, [updateChangeRequestFormTypeData]);

  useEffect(() => {
    switch (submitRequestFormInfoResponse?.IsSucceed) {
      case 1:
        const searchData = { ...requestFormInfoPayloadData };
        searchData.noticesTitle = "";
        searchData.pdfAttachPath = "";
        searchData.activeStatus = 0;
        searchData.postType = 1;

        dispatch(
          staffRequestAction?.updateRequestFormInfoPayloadData(searchData)
        );

        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode ? commonFacilityCode : 0,
            ProcedureName: StoredProcedures?.RequestPublicDefenderThreadRespond,
            UserAction: `MG User Responded to Inmate Request ( PRequestFormTypeID -${formID})`,
          })
        );

        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: facilityCode,
            createdBy: managementUserID,
          })
        );
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: managementUserID,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });
        const data = {
          folderPath: "",
          filename: "",
          file: "",
          fileSize: 0,
          fileType: "",
          requestForumThreadID: "",
          facilityID: facilityCode,
          facilityCode: "",
          inmatesId: "",
          managementUserID: managementUserID,
          activeStatus: 0,
          noticesTitle: "",
          pdfAttachPath: "",
          postType: 1,
        };
        dispatch(staffRequestAction?.resetRequestFormInfoPayloadData(data));
        getRequestFormDetails();
        getFormThreadListForTable();
        dispatch(staffRequestAction?.resetForm());
        setRequestFormSubmitted(true);
        showToastNotification("Form Submitted Successfully.", "success");
        break;

      case -1:
        showToastNotification("Operation Failed", "error");
        break;

      case -2:
        showToastNotification("Not Exist This Thread.", "error");
        break;

      case -3:
        showToastNotification("Text or Pdf File Empty", "error");
        break;

      default:
        break;
    }
  }, [submitRequestFormInfoResponse]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
      body {
        height: auto !important;
        overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
     
      .rdt_Pagination,
      .sc-diYFot jfOLQZ rdt_Pagination,
      .pagination-postion,
       .sc-diYFot,
       .jfOLQZ
        {
         display: none !important;
       }
    }
  `,
    content: () => {
      const combinedContent = document.createElement("div");
      if (componentRef2.current) {
        combinedContent.appendChild(componentRef2.current.cloneNode(true));
      }
      if (componentRef.current) {
        combinedContent.appendChild(componentRef.current.cloneNode(true));
      }
      if (componentRef1.current) {
        combinedContent.appendChild(componentRef1.current.cloneNode(true));
      }
      return combinedContent;
    },
    onBeforeGetContent: () => { },
  });

  function separatePathAndFileName(filePath) {
    // Find the last index of the '/' character
    const lastSlashIndex = filePath.lastIndexOf('/');

    // Extract folder path and file name

    let folderPath = filePath.substring(0, lastSlashIndex + 1);
    if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
      folderPath = `${process.env.REACT_APP_FOLDER_PATH}${filePath.substring(0, lastSlashIndex + 1)}`;
    }

    var filename = filePath.substring(lastSlashIndex + 1);

    return { folderPath, filename };
  }

  const handleDownloadPDF = (e, row) => {
    e?.preventDefault();
    const { folderPath, filename } = separatePathAndFileName(row?.PdfDocAttachPath);
    dispatch(
      staffRequestAction?.DownLoadFile({
        folderPath: folderPath,
        filename: filename,
      })
    )
      .then((result) => {
        setpdfdata(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to view PDF", "error");
      });
  };

  const exportRequestForm = async () => {
    let generateExcelColumns = ["Request", "Posted By", "Sent Date time"];
    const updateTotalRows = {
      ...requestFormTable,
      rowCountPerPage: loadInmateRequestFormList?.TotalRecordCount,
      exportExcel: true,
      formID: formID,
      pageNo: 1,
    };

    try {
      const result = await dispatch(
        staffRequestAction?.loadInmateRequestForumThreadList(updateTotalRows)
      );
      const dataList = result?.payload?.DataList;

      // Process each row asynchronously
      const exportData = await Promise.all(
        dataList?.map(async (obj) => ({
          Request:
            obj?.IsAttachDocPDF === 1 && obj?.IsPostText === 1
              ? (selectLang == "en" || selectLang == "es" ? (await translateText(obj.ForumPostBody, selectLang)) : obj.ForumPostBody) +
              " (Replied as PDF)"
              : obj?.IsAttachDocPDF === 1
                ? "(Replied as PDF)"
                : (selectLang == "en" || selectLang == "es" ? await translateText(obj.ForumPostBody, selectLang) : obj.ForumPostBody),
          "Posted By": (selectLang == "en" || selectLang == "es" ? await translateText(obj.ForumThreadPostBy, selectLang) : obj.ForumThreadPostBy),
          "Sent Date time": formatDateTimeAMPM(obj.ReqPostSendDate),
        }))
      );

      generateXlsx(exportData, generateExcelColumns, "Forum_List");
    } catch (err) {
      showToastNotification("Error in Export Data", "error");
    }
  };

  const column = [
    {
      name: "Request",
      width: "350px",
      selector: (row) => row.request,
      cell: (row, i) =>
        row.PostByInmate === 1 ? (
          <div div className="d-flex gap-2 ">
            <div className="d-flex  gap-2">
              <i
                className="fa-solid fa-reply inmate-replied fs-3"
                aria-hidden="true"
                title="Inmate Replied"
              ></i>
              <div
                className="pre-wrap-text"
                dangerouslySetInnerHTML={{
                  __html:
                    updateRequestColumn?.length > 0
                      ? updateRequestColumn[i]
                      : showmessagecontent(row?.ForumPostBody),
                }}
              ></div>
            </div>

            {row?.PdfDocAttachPath && (
              <div className="d-flex  align-items-center gap-2">
                <Link
                  className="btn button-success  btn-lg w-inherit cursor-pointer"
                  onClick={(e) => handleDownloadPDF(e, row)}
                >
                  <i class="fa-solid fa-file-pdf me-2"></i>
                  View PDF
                </Link>
              </div>
            )}
          </div>
        ) : (
          // Example "else if" condition
          <div div className="d-flex flex-wrap  gap-2 align-items-start">
            <div className="d-flex  gap-2">
              <i
                className="fa-solid fa-user-shield admin-replied fs-3"
                aria-hidden="true"
                title="Admin Replied"
              />
              <div
                className="pre-wrap-text"
                dangerouslySetInnerHTML={{
                  __html:
                    updateRequestColumn?.length > 0
                      ? updateRequestColumn[i]
                      : showmessagecontent(row?.ForumPostBody),
                }}
              ></div>
            </div>

            {row?.PdfDocAttachPath && (
              <Link
                className="btn button-success btn-lg w-inherit cursor-pointer"
                onClick={(e) => handleDownloadPDF(e, row)}
              >
                <i class="fa-solid fa-file-pdf me-2"></i>
                View PDF
              </Link>
            )}
          </div>
        ),
      sortable: false,
    },

    {
      name: "Posted By",
      selector: (row) => row.ForumThreadPostBy,
      cell: (row, i) => (
        <div
          className="d-flex flex-wrap gap-2"
          dangerouslySetInnerHTML={{
            __html:
              updatePostByColumn?.length > 0
                ? updatePostByColumn[i]
                : showmessagecontent(row?.ForumThreadPostBy),
          }}
        ></div>
      ),
      sortable: false,
    },
    {
      name: "Sent Date Time",
      selector: (row) => formatDateTimeAMPM(row.ReqPostSendDate),
      sortable: false,
    },
  ];

  const handleRowPerPage = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
      pageNo: 1
    }));
  };

  const handlePageChange = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);

    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload PDF Document.",
      }));
      const data = { ...requestFormInfoPayloadData };
      data["file"] = { type: "", size: 0 };
      data["fileType"] = "";
      data["fileSize"] = 0;
      dispatch(staffRequestAction?.updateRequestFormInfoPayloadData(data));
      return;
    }

    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...requestFormInfoPayloadData };
        data["file"] = { type: fileType, size: 0 };
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        dispatch(staffRequestAction?.updateRequestFormInfoPayloadData(data));
        // setRequestFormData(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...requestFormInfoPayloadData };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        // formData["filename"] = removedExtraTxt + "_" + timestamp + ".pdf";
        formData["filename"] = removedExtraTxt;

        formData["facilityCode"] =
          GetFacilityStaffReqInfoResponse?.FacilityName;

        dispatch(
          staffRequestAction?.updateRequestFormInfoPayloadData(formData)
        );
        // setRequestFormData(formData);
      };
      reader.readAsDataURL(files[0]);
    }
    const formData = { ...requestFormInfoPayloadData };
    if (type === "radio") {
      setErrorMessage({});
      formData[name] = parseInt(value);
      formData["noticesTitle"] = "";
      formData["file"] = "";
      formData["fileType"] = "";
      formData["fileSize"] = 0;
      formData["filename"] = "";
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
    }

    if (type === "checkbox") {
      formData[name] = checked ? 1 : 0;
    }

    if (type === "textarea") {
      if (/^\s/.test(value)) return;
      formData[name] = value;
    }
    dispatch(staffRequestAction?.updateRequestFormInfoPayloadData(formData));
    // setRequestFormData(formData);
  };

  // const handleValidation = (e, name) => {
  //   const { error } = staffRequestSchema(requestFormInfoPayloadData);
  //   const errorList = { ...errorMessage };
  //   if (error?.details) {
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
  //     }));
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       if (fieldError) {
  //         element.classList.add("input-error");
  //       } else {
  //         element.classList.remove("input-error");
  //       }
  //     }
  // } else {
  //   delete errorList[name];
  //   setErrorMessage(errorList);
  //   const element = document.querySelector(`[name="${name}"]`);
  //   if (element) {
  //     element.classList.remove("input-error");
  //   }
  //   // submitRequestFormInfo();
  // }
  // };

  const handleValidation = (e, name) => {
    const requestData = { ...requestFormInfoPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = staffRequestSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };
  const handleValidationForChangeFormType = (e, name) => {
    const requestData = { ...requestFormTypePopup };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = requestFormChangeFormTypeValidation(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleRequestFormTypeChange = () => {
    setFormType(formType === 1 ? 2 : 1);
    if (formType === 1) {
      dispatch(
        staffRequestAction?.getFormTypeList({
          formID: RequestFormType,
          FacilityCode: facilityCode,
        })
      );
    }
  };

  const handleFormTypeChange = (e) => {
    setErrorMessage({});
    setRequestFormTypePopUp({
      ...requestFormTypePopup,
      newRequestFormTypeId: e?.value,
    });
    setUpdateRequestFormType({
      ...updateRequestFormType,
      newRequestFormTitle: e?.label,
      newRequestFormTypeID: e?.value,
    });
  };

  const handleUpdateFormTypePopup = () => {
    const payload = { ...requestFormTypePopup };
    payload.requestFormTypeID = RequestFormType;
    const { error } = requestFormChangeFormTypeValidation(payload);
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    dispatch(staffRequestAction?.updateRequestFormTypePopup(payload));
  };

  const handleCancelBtn = () => {
    setFormType(1);
    setErrorMessage({});
    const payload = { ...requestFormTypePopup };
    payload.newRequestFormTypeId = 0;
    setRequestFormTypePopUp(payload);
  };

  const submitRequestFormInfo = () => {
    const requestData = { ...requestFormInfoPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    if (requestData?.activeStatus != 1) {
      const { error } = staffRequestSchema(requestData);
      setErrorMessage({});
      if (error?.details) {
        error?.details?.map((e) => {
          const { path } = e;
          setErrorMessage((prev) => ({
            ...prev,
            [path[0]]: e?.message,
          }));
        });
        return;
      }
      if (Object?.keys(errorMessage)?.length > 0) return;
    }
    const data = { ...requestFormInfoPayloadData };
    data.inmatesId = InmateID;
    data.PodCode = "";
    data.managementUserID = loggedUser;
    data.facilityID = facilityCode;
    data.requestForumThreadID = formID;
    dispatch(staffRequestAction?.submitRequestFormInfo(data));
  };

  const handleFormReset = () => {
    setErrorMessage({});
    const data = { ...requestFormInfoPayloadData };
    data.noticesTitle = "";
    data.postType = 1;
    data.activeStatus = 0;

    dispatch(staffRequestAction?.resetRequestFormInfoPayloadData(data));
    // setRequestFormData({
    //   ...updateRequestFormInfoPayloadData,
    // noticesTitle: "",
    // postType: 1,
    // activeStatus: 0,
    // });
  };

  const handleTranslate = async (
    language,
    data = loadInmateRequestFormList
  ) => {
    setselectLang(language);
    setTransLoader(true);
    const request = data?.DataList.map((msg) => msg.ForumPostBody);
    const postBy = data?.DataList.map((msg) => msg.ForumThreadPostBy);

    const translatedRequest =
      language === "es" || language === "en"
        ? await translateText(request, language)
        : request;

    const translatedPostBy =
      language === "es" || language === "en"
        ? await translateText(postBy, language)
        : postBy;

    const requestColumn = translatedRequest?.map((text) => {
      return `<span>${text}</span>`;
    });
    const posyByColumn = translatedPostBy?.map((text) => {
      return `<span>${text}</span>`;
    });
    setUpdateRequestColumn(requestColumn);
    setUpdatePostByColumn(posyByColumn);
    setTransLoader(false);
  };

  useEffect(() => {
    handleTranslate(selectLang)
  }, [selectLang])

  const showmessagecontent = (Value) => {
    const highlightedMessageContent = `<span >${Value}</span>`;
    return highlightedMessageContent;
  };

  if (loading || facilityLoader || transLoader) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3  w-100">
        {pdfdata && (
          <div className="d-flex flex-wrap justify-content-end gap-3">
            <Button
              label="Back"
              type="button"
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                setpdfdata(null);
              }}
            />
          </div>
        )}

        {pdfdata ? (
          <PdfViewer data={`data:application/pdf;base64,${pdfdata}`} />
        ) : (
          <div>
            <FormHeader
              requestReview={requestReview}
              list={formDetails}
              handlePrints={handlePrints}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              requestFormSubmitted={requestFormSubmitted}
              setRequestFormSubmitted={setRequestFormSubmitted}
              setFormType={setFormType}
              requestFormTypePopup={requestFormTypePopup}
              setRequestFormTypePopUp={setRequestFormTypePopUp}
            // formName="Request Form"
            />

            <div className="request-remedy-form">
              <div>
                <div>
                  <div ref={componentRef2}>
                    <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                      <div className="d-flex req-header-img">
                        {GetFacilityStaffReqInfoResponse?.LogoFile && (
                          <img
                            src={
                              "data:image/png;base64," +
                              GetFacilityStaffReqInfoResponse?.LogoFile
                            }
                            alt="facility-logo"
                            className="req-img"
                          />
                        )}
                      </div>
                      <div className="justify-content-center align-items-center req-header-title">
                        <h3 className="text-color py-2 text-center">
                          <span className="label-red req-text">
                            {GetFacilityStaffReqInfoResponse?.FacilityName?.toUpperCase()}
                          </span>
                        </h3>
                      </div>
                    </div>

                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-circle-info me-2"></i> FORUM
                      INFORMATION
                    </h4>
                  </div>
                  <div
                    ref={componentRef}
                    className="m-1 row border-bottom-1 request-form-card details-legal"
                  >
                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-circle-info me-2"></i> REQUEST
                      INFO
                    </h4>
                    {[
                      {
                        label: "Title",
                        value: requestFormInfoResponse?.ForumThreadTitle,
                      },
                      {
                        label: "Inmate ID",
                        value: requestFormInfoResponse?.InmateResidentId,
                      },
                      {
                        label: "Inmate Name",
                        value: requestFormInfoResponse?.InmateFullName,
                      },
                      {
                        label: "Created By",
                        value:
                          requestFormInfoResponse?.IsCreatedByMuUser === 1
                            ? requestFormInfoResponse?.MuUserFullName
                              ? requestFormInfoResponse?.MuUserFullName
                              : "-"
                            : requestFormInfoResponse?.InmateFullName,
                      },
                      {
                        label: "Created On",
                        value: requestFormInfoResponse?.RequestCreateDate,
                      },
                      {
                        label: "POD",
                        value: requestFormInfoResponse?.PodCode
                          ? requestFormInfoResponse?.PodCode
                          : "-",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                      >
                        <div className="user-information d-flex flex-wrap align-items-center">
                          <div className="fs-5 p-2  value-info">
                            {item.label}
                          </div>
                          <div className="p-1">:</div>
                          <div className="fs-5 p-2 text-start fw-bold value-text">
                            {item.value || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {showReplyModal && formType === 1 && (
                    <div className="mt-3 m-2">
                      <Button
                        label="Change Request Form Type"
                        status="btn-label"
                        type="button"
                        icon={"fa-solid fa-arrows-rotate"}
                        onClick={() => handleRequestFormTypeChange(formType)}
                        title="Change Request Form Type"
                      />
                    </div>
                  )}

                  {formType === 1 ? (
                    <div>
                      {showReplyModal && (
                        <>
                          <div className="details-legal d-flex flex-wrap  border-0">
                            <span className="mb-0 request-form-label">
                              Reply Mode
                            </span>
                            <RadioInput
                              name="postType"
                              id="postType"
                              options={ReplyMode}
                              handleChange={(e) => handleChange(e)}
                              selectedValue={
                                requestFormInfoPayloadData?.postType
                              }
                            />
                          </div>
                          <div className="details-legal">
                            {(requestFormInfoPayloadData?.postType === 1 ||
                              requestFormInfoPayloadData?.postType === 3) && (
                                <TextAreaInput
                                  placeholder="Enter Your Description"
                                  name="noticesTitle"
                                  handleChange={(e) => handleChange(e)}
                                  value={
                                    requestFormInfoPayloadData?.noticesTitle || ""
                                  }
                                  errorMessage={errorMessage}
                                  handleBlur={(e) => {
                                    handleValidation(e, "noticesTitle");
                                  }}
                                  labelClassName={"h-25"}
                                  maxLength={2000}
                                />
                              )}
                            {(requestFormInfoPayloadData?.postType === 2 ||
                              requestFormInfoPayloadData?.postType === 3) && (
                                <FileInput
                                  acceptFormat=".pdf"
                                  name="file"
                                  handleFileChange={(e) => handleChange(e)}
                                  errorMessage={errorMessage}
                                  id="fileInput"
                                />
                              )}
                          </div>
                          <div className="details-legal border-0">
                            <CheckBoxInput
                              name="activeStatus"
                              id="activeStatus"
                              label="Close"
                              handleClick={(e) => handleChange(e)}
                              checked={requestFormInfoPayloadData?.activeStatus}
                            />
                          </div>
                          <div className=" pb-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                            <Button
                              label="Submit"
                              status="success"
                              icon={"fa-solid fa-floppy-disk"}
                              type="button"
                              onClick={() => submitRequestFormInfo()}
                              title={"Submit"}
                            />
                            <Button
                              label="Reset"
                              title="Reset"
                              icon={"fa-solid fa-rotate-right"}
                              status="secondary"
                              type="button"
                              onClick={() => handleFormReset()}
                            />
                          </div>
                        </>
                      )}

                      <div className="m-3  d-flex flex-wrap mobile-left align-items-center gap-3">
                        <Button
                          label="Traducir al español"
                          title="Traducir al español"
                          status="btn-label"
                          type="button"
                          className={"w-max"}
                          icon={"language"}
                          onClick={() => setselectLang("es")}
                        />

                        <Button
                          label="Translate to English"
                          title="Translate to English"
                          status="btn-label"
                          type="button"
                          className={"w-max"}
                          icon={"globe"}
                          onClick={() => setselectLang("en")}
                        />
                        <Button
                          label="Reset"
                          title="Reset"
                          icon={"fa-solid fa-rotate-right"}
                          status="btn-label"
                          type="button"
                          onClick={() => setselectLang("")}
                        />
                        <ExcelExport
                          variant="soft-gray"
                          handleExcelExport={exportRequestForm}
                        />
                      </div>
                      <div ref={componentRef1}>
                        <Table
                          columns={column}
                          data={loadInmateRequestFormList?.DataList}
                          pagination
                          onChangeRowsPerPage={handleRowPerPage}
                          onChangePage={handlePageChange}
                          totalRowCount={
                            loadInmateRequestFormList?.TotalRecordCount
                          }
                          currentPage={requestFormTable?.pageNo}
                          paginationPerPage={requestFormTable.rowCountPerPage}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="details-legal">
                      <SelectInput
                        cName={"w-100"}
                        name="newRequestFormTypeId"
                        options={formTypeListDropDown}
                        handleChange={(e) => handleFormTypeChange(e)}
                        label="Change To Form Type"
                        value={requestFormTypePopup?.newRequestFormTypeId}
                        errorMessage={errorMessage}
                        handleBlur={(e) => {
                          handleValidationForChangeFormType(
                            e,
                            "newRequestFormTypeId"
                          );
                        }}
                        isClearable={requestFormTypePopup?.newRequestFormTypeId}
                      />
                      <div className="pt-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                        <Button
                          label="Update"
                          title="Update"
                          status="success"
                          icon={"fa-solid fa-pen-to-square"}
                          type="button"
                          onClick={() => handleUpdateFormTypePopup()}
                        />
                        <Button
                          label="Cancel"
                          title="Cancel"
                          status="secondary"
                          icon={"fa-solid fa-xmark"}
                          type="button"
                          // onClick={() => setFormType(1)}
                          onClick={() => handleCancelBtn()}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(RequestFormInfo);
